import { del, get, post, put } from '../utils/axios'

export const getDepartmentsAPI = async (param) => {
  return await get('departments', param)
}

export const createDepartmentsAPI = async (body) => {
  return await post('departments', body)
}

export const updateDepartmentsAPI = async (param, body) => {
  return await put('departments', param, body)
}

export const deleteDepartmentsAPI = async (param) => {
  return await del('departments', param)
}

export const getDepartmentsExpandAPI = async (param) => {
  return await get('search/department/th-eng', param)
}